console.log(process.env.REACT_APP_BACKEND_URI);
const BASE_URL = process.env.REACT_APP_BACKEND_URI;
// const BASE_RL = "https://www.backend.novocreation.com/";
export default BASE_URL;
